import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment';
import adicionarFiltroMdfe from '../../actions/mdfe/adicionarFiltroMdfe';
import removerFiltroMdfe from '../../actions/mdfe/removerFiltroMdfe';
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaMdfe extends Component {
  render() {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isNome={this.props.isNome}
        isRadio={this.props.isRadio}
        isNumero={this.props.isNumero}
        isPorcentagem={this.props.isPorcentagem}
        isValorMonetario={this.props.isValorMonetario}
        isFiltroData={this.props.isFiltroData}
        isFiltroHora={this.props.isFiltroHora}
        adicionarFiltro={this.props.adicionarFiltroMdfe}
        removerFiltro={this.props.removerFiltroMdfe}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosMdfe
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroMdfe,
    removerFiltroMdfe,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaMdfe)
